import * as React from 'react';

import { Payment } from '../../../../models/payment.model';
import { Merchant } from '../../../../models/merchant.model';
import { displayAmount } from '../../../../helpers/currency';
import { successIcon, resultMessage } from '../payment-page.component.styles';
import { ReactComponent as SuccessIcon } from '../../../../images/wv-icon-circle-check.svg';

export interface Props {
  payment: Payment;
  merchant: Merchant;
}

export const SuccessComponent = (props: Props) => {
  return (
    <div className={resultMessage}>
      <h1>Success!</h1>
      <p>
        Your payment of <strong>{displayAmount(props.payment.amount)}</strong> was sent to{' '}
        {props.merchant.name}
        {props.payment.receiptEmail && (
          <>
            {' '}
            and a receipt has been sent to <strong>{props.payment.receiptEmail}</strong>
          </>
        )}
        .
        {props.merchant && props.merchant.statementDescriptor && (
          <p>
            A charge from {props.merchant.statementDescriptor} will appear on your credit
            card statement.
          </p>
        )}
      </p>
      <SuccessIcon className={successIcon} />
    </div>
  );
};
